export const ROLES = {
  ADMIN: {
    value: 'admin',
    label: 'Administrator'
  },
  KEEPER: {
    value: 'keeper',
    label: 'Keeper'
  },
  EMPLOYEE: {
    value: 'employee',
    label: 'Employee'
  },
  CONSULTANT: {
    value: 'consultant',
    label: 'Farm Consultant'
  },
  VETERINARY: {
    value: 'veterinary',
    label: 'Veterinary'
  },
  OWNER: {
    value: 'owner',
    label: 'Livestock Owner'
  }
};

export const ALL_ROLES = Object.entries(ROLES).map(([key, value]) => value.value);

export const ROLES_TO_SHOW_SUBSCRIPTION_TAB = [ROLES.KEEPER.value, ROLES.ADMIN.value, ROLES.OWNER.value];
